import { TypographyVariant } from '../../tokens';
import { InputSize } from './types';

export const inputTextSize = (inputSize: InputSize): TypographyVariant => {
  switch (inputSize) {
    case 's':
      return '13_400';
    case 'm':
      return '14_400';
    case 'l':
      return '16_400';
    case 'xl':
      return '16_400';
    default:
      return '14_400';
  }
};
